import React from "react";
import locationImage from "../assets/PlanAVisit/beautiful1.jpg";
import {CiFacebook,FaInstagram,MdOutlineEmail,CiPhone} from "react-icons/fa";
import "./Location.css";


const ChurchLocation = () => {
  return (
    <section className="church-location-main">
      <div className="church-location-wrapper">

        {/* Left Side */}
        <div className="church-left">
          <div className="church-heading">
            <h2>
              APOSTOLIC <br />
              COMMUNITY <br />
              
            </h2>
          </div>

          {/* <div className="church-branch">
            <h3>Downtown</h3>
          </div> */}

          <div className="church-address">
            <p>Middle Boomtar,<br />Namchi-737126,<br/>South Sikkim,India</p>
          </div>

          <div className="church-service">
            <p>Service Times</p>
            <p><strong>9am</strong> | <strong>11am (ESP)</strong></p>
          </div>

          <div className="church-buttons">
            <button className="btn learn-more">LEARN MORE</button>
            <button className="btn directions">GET DIRECTIONS</button>
          </div>

          <div className="church-icons">
            <i className="fab fa-facebook"></i>  
            <i className="fab fa-instagram"></i>  
            <i className="fas fa-envelope"></i>   
            <i className="fas fa-phone"></i>      

          </div>
        </div>

        {/* Right Side */}
        <div className="church-right">
          <div className="church-paragraph">
            <p>
              We share a unified vision to exalt Jesus throughout Austin, and our individual
              campuses allow us to meet in smaller environments that reflect the diversity
              and unique nature of our city's neighborhoods.
            </p>
          </div>

          <div className="church-image">
            <img src={locationImage} alt="Church Location" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default ChurchLocation;
